import 'react-app-polyfill/ie11';
import React, { useState } from 'react';

import AppPagination from "components/common/AppPagination";

import '../Flights/FlightList.css';

const ErrorsForFlight = (props) => {
//const [data, setData] = useState([]);
    const data = [];
    const [paginationObject, setPaginationObject] = useState({ currPage: 1, pageSize: 10, startIndex: 0, endIndex: 10 });

    const backhandler = () => {
        props.history.goBack();
    }

    if (data === undefined) {
        return (null);
    }

    return (<>

        <div className="container">

            <div className="row justify-content-center" >
                <div className="col-12">
                    Errors for Flight
                </div>
                <div className="col-12">
                    Flight No':
                    <br />
                    Airline:
                </div>
            </div>
        </div>
        {data.length === 0 ? (
            <div className="table table-striped">
                <div className="row" style={{ background: "whitesmoke", padding: "15px" }}></div>
                <div className="row">
                    <div className="col" style={{ textAlign: 'center' }} >No data available in table </div>
                </div>
                <div className="row" style={{ background: "whitesmoke", padding: "15px" }}></div>
            </div>
        ) : (
            <div>
                <table className="table">
                    <thead>
                        <tr className="tableTitle">
                            <th scope="col">Error field name</th>
                            <th scope="col">Error field value</th>
                            <th scope="col">Error code</th>
                        </tr>
                    </thead>
                    <tbody>

                        {data.slice(paginationObject.startIndex, paginationObject.endIndex).map((item, i) => {
                            return (
                                <tr key={item.id} className="hand">
                                    <td style={{ textAlign: 'center' }}>{item.errorFieldName}</td>
                                    <td style={{ textAlign: 'center' }}>  {item.errorFieldValue}</td>
                                    <td style={{ textAlign: 'center' }}>{item.errorCode}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                <AppPagination
                    pageSize={paginationObject.pageSize}
                    totalRecords={data.length}
                    currentPage={paginationObject.currPage}
                    endIndex={paginationObject.endIndex}
                    startIndex={paginationObject.startIndex}
                    setPaginationObject={(ele) => {
                        setPaginationObject((data) => {
                            return ({ ...data, pageSize: ele.pageSize, startIndex: ele.startIndex, endIndex: ele.endIndex, currPage: ele.currPage })
                        })
                    }}
                >
                </AppPagination>
            </div>
        )}

        <div><button type="button" className="btn btn-secondary btn-block" onClick={backhandler}>Back</button></div>
    </>

    )
}
export default ErrorsForFlight;

